import { Option } from "api/types/_public";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import BreadCrumb from "components/Common/BreadCrumb";
import CopyWrapper from "components/Common/CopyWrapper";
import DropdownPoolOption from "components/Common/DropdownPoolOption";
import DropdownStatus from "components/Common/DropdownStatus";
import DropdownWalletOption from "components/Common/DropdownWalletOption";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { CAMPAIGN_TYPE, CAMPAIGN_TYPE_OPTIONS, DECIMALS_SOL, FEE_TIER_OPTIONS, FUNDING_INFO_TYPE, POSITION_TYPE, POSITION_TYPE_COLOR, POSITION_TYPE_LABEL, QUOTE_TOKEN_SOL, TOKENS_DEFAULT } from "helpers/constans";
import { customToFixed, formatNumberWithCommas } from "helpers/format";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalHeader, Offcanvas, OffcanvasBody, OffcanvasHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { ROUTES } from "routes/allRoutes";
import {
    NumberParam,
    StringParam,
    useQueryParams,
    withDefault,
} from "use-query-params";
import { getAllToken, getAssetCampaign, getCampaigns as onGetCampaigns, getOptionPools as onGetOptionPools, getWallets as onGetWallets, runCampaign, stopCampaign, updateBootingConfigCampaign, getCentralWallet } from "../../store/thunks";
import CampaignConfiguration from "./CampaignConfiguration";
import CampaignFunding from "./CampaignFunding";
import CampaignAllocation from "./CampaignAllocation";

const TYPE_SELECT_DEFAULT: string = "id";
const MAX_WIDTH_SCREEN = 1800;

export default function Campaign() {
    const { t, i18n } = useTranslation();

    const navigate = useNavigate();

    const CAMPAIGN_TYPE_OPTIONS_LANG = CAMPAIGN_TYPE_OPTIONS.map((item: any) => ({
        label: t(item.label),
        value: item.value
    }));

    const STATUS_BOT_OPTIONS_LANG: any = [{ value: 'ACTIVATED', label: 'Running' }, { value: 'DEACTIVATED', label: 'Stop' }, { value: 'CLOSED', label: 'Close' }]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const TYPE_BOT_OPTIONS_LANG: any = [{ value: 'buy', label: 'Label_Buy' }, { value: 'sell', label: 'Label_Sell' }]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 100),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        name: withDefault(StringParam, ""),
        type: withDefault(StringParam, ""),
        status: withDefault(StringParam, ""),
        pool: withDefault(StringParam, ""),
        wallet: withDefault(StringParam, ""),
    });

    const [typeSearch, setTypeSearch] = useState<Option | null>(TYPE_BOT_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.type)) || null);

    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_BOT_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.status)) || null);

    const [poolSearch, setPoolSearch] = useState<Option | null>(null);

    const [walletSearch, setWalletSearch] = useState<Option | null>(null);

    const [isCallingInterval, setIsCallingInterval] = useState<boolean>(false);

    const [isCountdown, setIsCountdown] = useState<boolean>(false);

    const [isOpenBotFrom, setIsOpenBotFrom] = useState<boolean>(false);

    const [isLoadingAssetWallet, setIsLoadingAssetWallet] = useState<boolean>(false);

    const [assetWallets, setAssetWallets] = useState<any[]>([]);

    const [isBootingConfig, setIsBootingConfig] = useState<boolean>(false);

    const [isOpenConfirmUpdateStatusBot, setIsOpenConfirmUpdateStatusBot] = useState<boolean>(false);
    const [isConfirmUpdateStatusBotLoading, setIsConfirmUpdateStatusBotLoading] = useState<boolean>(false);
    const [statusBot, setStatusBot] = useState<{ id: string | number, status: string } | null>(null);

    const [fundingCampaign, setFundingCampaign] = useState<any>(null);

    const [allocationCampaign, setAllocationCampaign] = useState<any>(null);

    const [windowSize, setWindowSize] = useState<{ width: number, height: number }>({ width: 0, height: 0 });

    const [listTokenA, setListTokenA] = useState<any[]>([]);
    const [listTokenB, setListTokenB] = useState<any[]>([]);

    const [idCampaign, setIdCampaign] = useState<string | number | null>(null);

    const [walletCentral, setWalletCentral] = useState<any>(null);

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => {
        return state.Campaign;
    };

    const selectLayoutStatePool = (state: any) => {
        return state.Pool;
    };

    const selectLayoutStateWallet = (state: any) => {
        return state.Wallet;
    };

    const CampaignProperties = createSelector(selectLayoutState, (state) => ({
        campaigns: state.campaigns,
        isCampaignSuccess: state.isCampaignSuccess,
        isCampaignLoading: state.isCampaignLoading,
        error: state.error,
    }));


    // Inside your component
    const { campaigns, error, isCampaignLoading } = useSelector(CampaignProperties);

    useEffect(() => {
        dispatch(onGetCampaigns(query));
    }, [dispatch, JSON.stringify(query)]);


    const PoolProperties = createSelector(selectLayoutStatePool, (state) => ({
        optionPools: state.optionPools || [],
    }));

    const WalletProperties = createSelector(selectLayoutStateWallet, (state) => ({
        optionWallets: state.wallets || [],
    }));

    // Inside your component
    const { optionPools } = useSelector(PoolProperties);

    const { optionWallets } = useSelector(WalletProperties);


    const [listPool, setListPool] = useState<any>([]);

    const [listWallet, setListWallet] = useState<any>([]);

    useEffect(() => {
        dispatch(onGetOptionPools({ page: 1, limit: 1000 }));
        dispatch(onGetWallets({ page: 1, limit: 1000 }));
    }, []);

    const searchData = () => {
        setQuery({
            ...query,
            type: typeSearch?.value,
            status: statusSearch?.value,
            pool: poolSearch?.value,
            wallet: walletSearch?.value,
            page: 1,
            time_request: + new Date()
        });
    };

    const resetData = () => {
        setQuery({
            type: '',
            status: '',
            pool: '',
            wallet: '',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        }, "push")
        setTypeSearch(null);
        setStatusSearch(null);
        setPoolSearch(null);
        setWalletSearch(null);
    };

    const triggerRefresh = async (type: string = '') => {
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
    };

    const triggerRefreshBotForm = () => {
        triggerRefresh();
        setIsOpenBotFrom(false);
    };

    const handleCloseBotForm = () => {
        setIsOpenBotFrom(false);
        setIdCampaign(null);
    };

    const onOpenConfirmUpdateStatusBotClick = (bot: { id: string | number, status: string } | null) => {
        setStatusBot(() => bot);
        setIsOpenConfirmUpdateStatusBot(() => true);
    }

    const onCloseConfirmUpdateStatusBotClick = () => {
        setIsOpenConfirmUpdateStatusBot(() => false);
    }

    const handleActionUpdateStatusBot = async () => {
        try {
            if (!statusBot?.id || !!isConfirmUpdateStatusBotLoading) {
                return;
            }
            setIsConfirmUpdateStatusBotLoading((_prev) => true);
            const response: any = statusBot?.status === 'ACTIVATED' ? await runCampaign(statusBot?.id) : await stopCampaign(statusBot?.id);
            setIsConfirmUpdateStatusBotLoading((_prev) => false);
            if (!!response?.success) {
                onCloseConfirmUpdateStatusBotClick();
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                triggerRefresh();
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmUpdateStatusBotLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const handleDetailCampaign = (id: string | number) => {
        setIdCampaign(id);
        setIsOpenBotFrom(true);
    };

    const convertDate = (date: string) => {
        const arrDate = String(date || "").split("T");
        return `${arrDate?.[0] || ""} ${String(arrDate?.[1] || "")?.split('.')[0]}`;
    };

    const handleChangeIsBootingConfig = async (isBooting: boolean, id: string | number) => {
        try {
            setIsBootingConfig((_prev) => true);
            const response: any = await updateBootingConfigCampaign(id, { status: isBooting });
            setIsBootingConfig((_prev) => false);
            if (!!response?.success) {
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                triggerRefresh();
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            return error;
        }
    };


    const handleFundingCampaign = (campaign: any) => {
        setFundingCampaign(() => campaign);
    };

    const handleCloseFundingCampaign = () => {
        setFundingCampaign(null);
    };


    const handleAllocationCampaign = (campaign: any) => {
        setAllocationCampaign(() => campaign);
    };

    const handleCloseAllocationCampaign = () => {
        setAllocationCampaign(null);
    };


    const formatPositionTokenInPool = (poolInfo: any) => {
        const _poolInfo = structuredClone(poolInfo);
        if (_poolInfo?.tokenA !== _poolInfo?.tokens?.[0]?.tokenAddress) {
            return ({
                ..._poolInfo,
                tokens: (_poolInfo?.tokens).reverse()
            });
        }
        return _poolInfo;
    };


    // Column
    const columns = useMemo(
        () => [
            // {
            //     Header: t("ID"),
            //     accessor: "ID",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 50,
            //     Cell: (cell: any) => (
            //         <>
            //             <span style={{ minWidth: "50px" }}>{cell?.value}</span>
            //         </>
            //     ),
            // },
            {
                Header: t("Status"),
                accessor: "status",
                filterable: true,
                sortable: false,
                thWidth: 100,
                Cell: (cell: any) => {
                    const item = cell?.row?.original?.campaignInfo;
                    const COLOR: any = {
                        ACTIVATED: 'success',
                        DEACTIVATED: 'danger',
                        CLOSED: 'warning',
                        PROCESSING: 'info',
                    };
                    return (
                        <>
                            <div style={{ minWidth: "80px" }}>
                                <span className={`rounded-pill badge bg-${COLOR?.[item?.status] || 'secondary'}`}>{STATUS_BOT_OPTIONS_LANG?.find((_i: any) => String(_i?.value) === String(item?.status))?.label || t('Processing')}</span>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Pool"),
                accessor: "token_info",
                filterable: true,
                sortable: false,
                thWidth: 200,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = item?.poolInfo || {};
                    const tokenA = pairInfo?.tokens?.[0];
                    const tokenB = pairInfo?.tokens?.[1];
                    return (
                        <>
                            <div style={{ minWidth: "180px" }}>
                                {pairInfo?.pairAddress ? <>
                                    <div className=" d-flex align-items-start flex-column gap-2">
                                        <div className="d-flex space-x-2 position-relative align-items-center">
                                            <TooltipCustom
                                                title={tokenA?.tokenSymbol || ''}
                                                className="d-inline-block vertical-align-middle"
                                                style={{ transform: 'translateY(2px)' }}
                                            >
                                                <span className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xs text-gray-900">
                                                    {!!tokenA?.tokenLogo ? <img src={tokenA?.tokenLogo} alt="Token Icon" className="w-10 h-10 rounded-full" /> : String(tokenA?.tokenSymbol)?.split('')?.[0] || ''}
                                                </span>
                                            </TooltipCustom>
                                            <div className="ms-2">
                                                <div><strong className="fs-16">{tokenA?.tokenSymbol || '-'}</strong> <span className="text-muted">/</span> <span className="fs-13 text-muted">{tokenB?.tokenSymbol || '-'}</span></div>
                                                <div className="fs-12 text-muted">
                                                    <Link to={`https://solscan.io/account/${pairInfo?.pairAddress}`} target="_blank" className="d-inline-block">
                                                        <CopyWrapper
                                                            isShow={true}
                                                            contentCopy={pairInfo?.pairAddress}
                                                        >
                                                            {pairInfo?.pairAddress ? (
                                                                <span>
                                                                    {pairInfo?.pairAddress?.slice(0, 7) +
                                                                        "..." +
                                                                        pairInfo?.pairAddress?.slice(-4)}
                                                                </span>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </CopyWrapper>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="position-absolute" style={{ bottom: 0, transform: 'translate(10px, 4px)' }}>
                                                <TooltipCustom
                                                    title={tokenB?.tokenSymbol || ''}
                                                    className="d-inline-block vertical-align-middle"
                                                    style={{ transform: 'translateY(2px)' }}
                                                >
                                                    <span className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center text-xs text-gray-900">
                                                        {!!tokenB?.tokenLogo ? <img src={tokenB?.tokenLogo} alt="Token Icon" className="w-6 h-6 rounded-full" /> : String(tokenB?.tokenSymbol)?.split('')?.[0] || ''}
                                                    </span>
                                                </TooltipCustom>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" d-flex align-items-center mt-3">
                                        <img src={tokenA?.tokenLogo} alt={tokenA?.tokenSymbol} className="w-[14px] h-[14px] rounded-full" />
                                        <span className="text-muted font-normal mx-1 fs-14">{tokenA?.tokenSymbol} -</span>
                                        <span className="text-muted font-normal fs-12">
                                            <CopyWrapper
                                                isShow={true}
                                                contentCopy={tokenA?.tokenAddress}
                                            >
                                                {tokenA?.tokenAddress?.slice(0, 7) + "..." + tokenA?.tokenAddress?.slice(-3)}
                                            </CopyWrapper>
                                        </span>
                                    </div>
                                    <div className=" d-flex align-items-center">
                                        <img src={tokenB?.tokenLogo} alt={tokenB?.tokenSymbol} className="w-[14px] h-[14px] rounded-full" />
                                        <span className="text-muted font-normal mx-1 fs-14">{tokenB?.tokenSymbol} -</span>
                                        <span className="text-muted font-normal fs-12">
                                            <CopyWrapper
                                                isShow={true}
                                                contentCopy={tokenB?.tokenAddress}
                                            >
                                                {tokenB?.tokenAddress?.slice(0, 7) + "..." + tokenB?.tokenAddress?.slice(-3)}
                                            </CopyWrapper>
                                        </span>
                                    </div>
                                </> : <>-</>}
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Campaign Statistics"),
                accessor: "campaignStatistics",
                filterable: true,
                sortable: false,
                thWidth: 360,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const tokenB = pairInfo?.tokens?.[1];
                    const campaignInfo = item?.campaignInfo || {};
                    const totalCapital = campaignInfo?.total_capital || 0;
                    const targetProfit = campaignInfo?.target_profit || 0;
                    const stopLoss = campaignInfo?.stop_loss || 0;
                    const currentProfit = campaignInfo?.current_profit || 0;
                    const totalCapitalB = Number(campaignInfo?.total_quote || 0) / Math.pow(10, Number(tokenB?.tokenDecimals));
                    const totalCapitalSOL = Number(campaignInfo?.total_volume_sol || 0);
                    const quoteToken = pairInfo?.tokens?.find((_token: any) => _token?.tokenAddress === pairInfo?.quoteToken);
                    const totalFeeInQuote = Number(campaignInfo?.total_fee_in_quote || 0) / Math.pow(10, Number(quoteToken?.tokenDecimals));
                    const totalGasFee = Number(campaignInfo?.total_gas_fee || 0) / Math.pow(10, Number(DECIMALS_SOL));
                    return (
                        <>
                            <div style={{ minWidth: "340px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Current Profit')}: <span className="font-bold text-primary">{formatNumberWithCommas(customToFixed(currentProfit, 3))}</span> <span className="text-muted">(USD)</span>
                                </div>
                                <div>
                                    {t('Target Profit')}: <span className="text-success">{formatNumberWithCommas(customToFixed(targetProfit, 3))}</span> <span className="text-muted">(USD)</span>
                                </div>
                                <div>
                                    {t('Stop Loss')}: <span className="text-danger">{formatNumberWithCommas(customToFixed(stopLoss, 3))}</span> <span className="text-muted">(USD)</span>
                                </div>
                                <div>
                                    {t('Total Capital')}: <span className="text-primary">
                                        {formatNumberWithCommas(customToFixed(totalCapital, 3))}</span> <span className="text-muted">(USD)</span>  = <>{quoteToken?.tokenAddress !== QUOTE_TOKEN_SOL && <><span className="text-primary">{totalCapitalB}</span> <span className="text-muted">({tokenB?.tokenSymbol})</span> +</>}</> <span className="text-primary">{totalCapitalSOL}</span> <span className="text-muted">(SOL)</span>
                                </div>
                                <div>
                                    {t('LP Fee')}: <span className="text-primary"> {formatNumberWithCommas(customToFixed(totalFeeInQuote))}</span> <span className="text-muted">({quoteToken?.tokenSymbol})</span>
                                    <span className="mx-2 text-muted">|</span>
                                    {t('Gas Fee')}: <span className="text-primary"> {totalGasFee}</span> <span className="text-muted">(SOL)</span>
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Pool Info"),
                accessor: "poolInfo",
                filterable: true,
                sortable: false,
                thWidth: 350,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const campaignInfo = item?.campaignInfo || {};
                    const mainPositionConfig = campaignInfo?.main_position_config || {};
                    const tokenMain = pairInfo?.tokens?.find((_token: any) => _token?.tokenAddress === mainPositionConfig?.input_token_mint);

                    return (
                        <>
                            <div style={{ minWidth: "330px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Campaign Type')}: <span className="font-bold text-primary">{CAMPAIGN_TYPE_OPTIONS_LANG?.find((_c: any) => String(_c?.value) === String(campaignInfo?.campaign_type))?.label || "-"}</span>
                                </div>
                                {String(campaignInfo?.campaign_type) === CAMPAIGN_TYPE.WITH_EXISTED_POOL && <div className="d-flex align-items-center">
                                    {t('Existed Pool')}:  <span className="text-muted font-normal fs-12 ms-1">
                                        <CopyWrapper
                                            isShow={true}
                                            contentCopy={campaignInfo?.target_pool}
                                        >
                                            {campaignInfo?.target_pool?.slice(0, 7) + "..." + campaignInfo?.target_pool?.slice(-4)}
                                        </CopyWrapper>
                                    </span>
                                </div>}
                                <div>
                                    {t('Slippage')}: <span className="">{mainPositionConfig?.slippage ?? "-"}</span>%
                                </div>
                                <div>
                                    {t('Initial Amount')}: <span className="font-bold text-primary">{customToFixed(Number(mainPositionConfig?.amount_in || 0) / Math.pow(10, Number(tokenMain?.tokenDecimals)), tokenMain?.tokenDecimals)}</span> <span className="text-muted">({tokenMain?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Initial Price')}: <span className="text-primary">{mainPositionConfig?.initial_price ?? "-"}</span> <span className="text-muted">({tokenMain?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Initial Price Range')}: <span className="text-primary">{mainPositionConfig?.range_lower ?? "-"}</span> ~ <span className="text-primary">{mainPositionConfig?.range_upper ?? "-"}</span> <span className="text-muted">({tokenMain?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Fee Tier')}: <span className="">{FEE_TIER_OPTIONS?.find((item: any) => String(item?.value) === String(mainPositionConfig?.tick_spacing))?.label || "-"}</span>
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Open Position Config"),
                accessor: "openPositionConfig",
                filterable: true,
                sortable: false,
                thWidth: 200,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const campaignInfo = item?.campaignInfo || {};
                    const mainPositionConfig = campaignInfo?.main_position_config || {};
                    const openPositionConfig = campaignInfo?.open_position_config || {};
                    const tokenMain = pairInfo?.tokens?.find((_token: any) => _token?.tokenAddress === mainPositionConfig?.input_token_mint);
                    return (
                        <>
                            <div style={{ minWidth: "180px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Amount In')}: <span className="font-bold text-primary">{customToFixed(Number(openPositionConfig?.amount_in || 0) / Math.pow(10, Number(tokenMain?.tokenDecimals)), tokenMain?.tokenDecimals)}</span> <span className="text-muted">({tokenMain?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Upper Edge')}: <span className="">{openPositionConfig?.upper_edge_percentage ?? "-"}</span>%
                                </div>
                                <div>
                                    {t('Lower Edge')}: <span className="">{openPositionConfig?.lower_edge_percentage ?? "-"}</span>%
                                </div>
                                <div>
                                    {t('New Range Position')}: <span className="">{openPositionConfig?.new_range_position_percentage ?? "-"}</span>%
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Close Position Config"),
                accessor: "closePositionConfig",
                filterable: true,
                sortable: false,
                thWidth: 280,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const campaignInfo = item?.campaignInfo || {};
                    const closePositionConfig = campaignInfo?.close_position_config || {};
                    const tokenB = pairInfo?.tokens?.[1];
                    return (
                        <>
                            <div style={{ minWidth: "260px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Target Profit')}: <span className="font-bold text-primary">{closePositionConfig?.profit_percentage ?? "-"}</span>%
                                </div>
                                <div>
                                    {t('Stop Loss')}: <span className="font-bold text-primary">{closePositionConfig?.stop_loss_percentage ?? "-"}</span>%
                                </div>
                                <div>
                                    {t('Total Wallet')}: <span className="font-bold text-primary">{closePositionConfig?.total_wallet ?? "-"}</span>
                                </div>
                                <div>
                                    {t('Total Amount Base')}: <span className="font-bold text-primary">{customToFixed(Number(closePositionConfig?.total_amount_base || 0) / Math.pow(10, Number(tokenB?.tokenDecimals)), tokenB?.tokenDecimals)}</span> <span className="text-muted">({tokenB?.tokenSymbol})</span>
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Boosting Config"),
                accessor: "boostingConfig",
                filterable: true,
                sortable: false,
                thWidth: 250,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const campaignInfo = item?.campaignInfo || {};
                    const isStatusBooting = campaignInfo?.boosting_config?.status;
                    const buyIncreasePercentage = campaignInfo?.boosting_config?.buy_increase_percentage || 0;
                    const sellDecreasePercentage = campaignInfo?.boosting_config?.sell_decrease_percentage || 0;
                    const probability = campaignInfo?.boosting_config?.probability || 0;
                    return (
                        <>
                            <div style={{ minWidth: "250px" }} className="d-flex align-items-start flex-column gap-2">
                                <div className="d-flex align-items-center gap-2">
                                    <strong>{t('Induce Price Increase')}:</strong>
                                    <div className="form-check form-switch form-switch-sm text-start" dir="ltr">
                                        <input type="checkbox" className="form-check-input" name="flg_click" id="is_booting_config" checked={Boolean(isStatusBooting || 0)}
                                            onChange={(event: any) => {
                                                handleChangeIsBootingConfig(event.target.checked, campaignInfo?.ID);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div>
                                    {t('Buy Increase Percentage')}: <span className="font-bold text-primary">{buyIncreasePercentage || "0"}</span>%
                                </div>
                                <div>
                                    {t('Sell Decrease Percentage')}: <span className="font-bold text-primary">{sellDecreasePercentage || "0"}</span>%
                                </div>
                                <div>
                                    {t('Probability')}: <span className="font-bold text-primary">{probability || "0"}</span>%
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Trade Config"),
                accessor: "tradeConfig",
                filterable: true,
                sortable: false,
                thWidth: 400,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const campaignInfo = item?.campaignInfo || {};
                    const tradeConfig = campaignInfo?.trade_config || {};
                    const quoteToken = pairInfo?.tokens?.find((_token: any) => _token?.tokenAddress === pairInfo?.quoteToken);
                    const isStatusBooting = campaignInfo?.boosting_config?.status;
                    return (
                        <>
                            <div style={{ minWidth: "380px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Total Wallet')}: <span className="font-bold text-primary">{tradeConfig?.total_wallet || "-"}</span>
                                </div>
                                <div>
                                    {t('Main Position Vol Range')}: <span className="font-bold text-primary">{customToFixed(Number(tradeConfig?.main_position_vol_range_min || 0) / Math.pow(10, Number(quoteToken?.tokenDecimals)), quoteToken?.tokenDecimals)}</span> ~ <span className="font-bold text-primary">{customToFixed(Number(tradeConfig?.main_position_vol_range_max || 0) / Math.pow(10, Number(quoteToken?.tokenDecimals)), quoteToken?.tokenDecimals)}</span> <span className="text-muted">({quoteToken?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Upper Position Sell Increase')}: <span className="">{tradeConfig?.upper_position_sell_increase || "-"}</span>%
                                </div>
                                <div>
                                    {t('Lower Position Buy Increase')}: <span className="">{tradeConfig?.lower_position_buy_increase || "-"}</span>%
                                </div>
                                <div>
                                    {t('Upper Position Buy Decrease')}: <span className="">{tradeConfig?.upper_position_buy_decrease || "-"}</span>%
                                </div>
                                <div>
                                    {t('Time Interval Range')}: <span className="text-primary">{tradeConfig?.interval_min || "-"}</span>s ~ <span className="text-primary">{tradeConfig?.interval_max || "-"}</span>s
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: `${t("Funding Info")} (${t("Position")})`,
                accessor: "fundingInfoPosition",
                filterable: true,
                sortable: false,
                thWidth: 220,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const campaignInfo = item?.campaignInfo || {};
                    const fundingInfoPosition = (campaignInfo?.list_funding_info || [])?.find((_item: any) => String(_item?.types) === String(FUNDING_INFO_TYPE?.POSITION)) || {};
                    const tokenA = pairInfo?.tokens?.[0];
                    const tokenB = pairInfo?.tokens?.[1];
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Amount A')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoPosition?.amount_a || 0) / Math.pow(10, Number(tokenA?.tokenDecimals)), tokenA?.tokenDecimals)}</span> <span className="text-muted">({tokenA?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Amount B')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoPosition?.amount_b || 0) / Math.pow(10, Number(tokenB?.tokenDecimals)), tokenB?.tokenDecimals)}</span> <span className="text-muted">({tokenB?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Amount Native')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoPosition?.amount_native || 0) / Math.pow(10, Number(DECIMALS_SOL)), DECIMALS_SOL)}</span> <span className="text-muted">(SOL)</span>
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: `${t("Funding Info")} (${t("Trade")})`,
                accessor: "fundingInfoTrade",
                filterable: true,
                sortable: false,
                thWidth: 220,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const campaignInfo = item?.campaignInfo || {};
                    const fundingInfoTrade = (campaignInfo?.list_funding_info || [])?.find((_item: any) => String(_item?.types) === String(FUNDING_INFO_TYPE?.TRADE)) || {};
                    const tokenA = pairInfo?.tokens?.[0];
                    const tokenB = pairInfo?.tokens?.[1];
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Amount A')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoTrade?.amount_a || 0) / Math.pow(10, Number(tokenA?.tokenDecimals)), tokenA?.tokenDecimals)}</span> <span className="text-muted">({tokenA?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Amount B')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoTrade?.amount_b || 0) / Math.pow(10, Number(tokenB?.tokenDecimals)), tokenB?.tokenDecimals)}</span> <span className="text-muted">({tokenB?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Amount Native')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoTrade?.amount_native || 0) / Math.pow(10, Number(DECIMALS_SOL)), DECIMALS_SOL)}</span> <span className="text-muted">(SOL)</span>
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: `${t("Funding Info")} (${t("Main Position")})`,
                accessor: "fundingInfoMain",
                filterable: true,
                sortable: false,
                thWidth: 220,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const campaignInfo = item?.campaignInfo || {};
                    const fundingInfoMain = (campaignInfo?.list_funding_info || [])?.find((_item: any) => String(_item?.types) === String(FUNDING_INFO_TYPE?.MAIN_POSITION)) || {};
                    const tokenA = pairInfo?.tokens?.[0];
                    const tokenB = pairInfo?.tokens?.[1];
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="d-flex align-items-start flex-column gap-2">
                                <div>
                                    {t('Amount A')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoMain?.amount_a || 0) / Math.pow(10, Number(tokenA?.tokenDecimals)), tokenA?.tokenDecimals)}</span> <span className="text-muted">({tokenA?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Amount B')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoMain?.amount_b || 0) / Math.pow(10, Number(tokenB?.tokenDecimals)), tokenB?.tokenDecimals)}</span> <span className="text-muted">({tokenB?.tokenSymbol})</span>
                                </div>
                                <div>
                                    {t('Amount Native')}: <span className="font-bold text-primary">{customToFixed(Number(fundingInfoMain?.amount_native || 0) / Math.pow(10, Number(DECIMALS_SOL)), DECIMALS_SOL)}</span> <span className="text-muted">(SOL)</span>
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Wallets"),
                accessor: "wallets",
                filterable: true,
                sortable: false,
                thWidth: 520,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const campaignInfo = item?.campaignInfo || {};
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const tokenA = pairInfo?.tokens?.[0];
                    const tokenB = pairInfo?.tokens?.[1];
                    const tokenDecimalsA = tokenA?.tokenDecimals;
                    const tokenDecimalsB = tokenB?.tokenDecimals;
                    const wallets = campaignInfo?.wallets || [];
                    const assetWallet = assetWallets?.find((_item: any) => String(_item?.ID) === String(campaignInfo?.ID))?.data || [];
                    const [showAllWallets, setShowAllWallets] = useState(false);

                    const walletsFull = wallets?.map((_wallet: any) => {
                        const w = assetWallet?.find((_item: any) => String(_item?.wallet) === String(_wallet?.pubkey));
                        return {
                            ..._wallet,
                            balanceA: customToFixed(Number(w?.balanceA || 0) / Math.pow(10, Number(tokenDecimalsA)), tokenDecimalsA),
                            balanceB: customToFixed(Number(w?.balanceB || 0) / Math.pow(10, Number(tokenDecimalsB)), tokenDecimalsB),
                            balanceNative: customToFixed(Number(w?.balanceNative || 0) / Math.pow(10, Number(DECIMALS_SOL)), DECIMALS_SOL),
                        };
                    });

                    const displayedWallets = showAllWallets ? walletsFull : walletsFull.slice(0, 3);

                    return (
                        <div style={{ minWidth: "500px" }} className="d-flex align-items-start flex-column gap-2">
                            {displayedWallets?.map((_wallet: any, index: number) => (
                                <div key={_wallet?.pubkey}>
                                    <CopyWrapper isShow={true} contentCopy={_wallet?.pubkey}>
                                        <div className="d-inline-block">
                                            <span className="text-muted">{index + 1}.</span> <span className="">{_wallet?.pubkey?.slice(0, 9) + "..." + _wallet?.pubkey?.slice(-5)}</span>
                                        </div>
                                    </CopyWrapper>
                                    <div className="d-flex align-items-center gap-1 ms-3">
                                        {tokenA?.tokenAddress !== QUOTE_TOKEN_SOL &&
                                            <>
                                                <div className="text-muted fs-13">{isLoadingAssetWallet ? <Spinner size="sm" /> : _wallet?.balanceA} <span className="text-muted fs-13">{tokenA?.tokenSymbol}</span></div>
                                                <div className="text-muted fs-13 mx-1">|</div>
                                            </>
                                        }
                                        {tokenB?.tokenAddress !== QUOTE_TOKEN_SOL &&
                                            <>
                                                <div className="text-muted fs-13">{isLoadingAssetWallet ? <Spinner size="sm" /> : _wallet?.balanceB} <span className="text-muted fs-13">{tokenB?.tokenSymbol}</span></div>
                                                <div className="text-muted fs-13 mx-1">|</div>
                                            </>
                                        }
                                        <div className="text-muted fs-13">{isLoadingAssetWallet ? <Spinner size="sm" /> : _wallet?.balanceNative} <span className="text-muted fs-13">SOL</span></div>
                                    </div>
                                </div>
                            ))}
                            {walletsFull.length > 3 && (
                                <button className="btn btn-link text-decoration-none p-0 mt-0" onClick={() => setShowAllWallets(!showAllWallets)}>
                                    {showAllWallets ? t("View Less") : t("View More")} ({walletsFull.length - 3})
                                </button>
                            )}
                        </div>
                    );
                },
            },
            {
                Header: t("Positions"),
                accessor: "positions",
                filterable: true,
                sortable: false,
                thWidth: 500,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = formatPositionTokenInPool(item?.poolInfo) || {};
                    const positions = Array.from(item?.campaignInfo?.list_position || []).reverse();
                    const tokenA = pairInfo?.tokens?.[0];
                    const tokenB = pairInfo?.tokens?.[1];
                    const mainPositionConfig = item?.campaignInfo?.main_position_config || {};
                    const tokenMain = pairInfo?.tokens?.find((_token: any) => _token?.tokenAddress === mainPositionConfig?.input_token_mint);
                    return (
                        <>
                            <div style={{ minWidth: "470px" }} className="d-flex align-items-start flex-column gap-2">
                                {
                                    positions?.map((_position: any) => (
                                        <div key={_position?.ID} className="d-flex align-items-start justify-content-center gap-1">
                                            <div className="align-self-center min-w-[52px] text-center">
                                                <span className={`badge rounded-pill border border-${POSITION_TYPE_COLOR[`${_position?.position_type}`]} text-${POSITION_TYPE_COLOR[`${_position?.position_type}`]}`}>{t(POSITION_TYPE_LABEL[`${_position?.position_type}`])}</span>
                                            </div>
                                            <div>
                                                <div>
                                                    <span className="fs-14"><span className="text-primary">{customToFixed(_position?.lower_price || 0, tokenB?.tokenDecimals)}</span> ~ <span className="text-primary">{customToFixed(_position?.upper_price || 0, tokenB?.tokenDecimals)}</span></span>
                                                    <span className="text-muted ms-1">({tokenMain?.tokenSymbol})</span>
                                                </div>
                                                <div>
                                                    <span className="fs-13">{t('Harvestable yield')}</span>: <span className="text-primary">{Number(_position?.fee_a) / Math.pow(10, Number(tokenA?.tokenDecimals))}</span> <span className="text-muted">({tokenA?.tokenSymbol})</span>
                                                    <span className="mx-2 text-muted">+</span>
                                                    <span className="text-primary">{Number(_position?.fee_b) / Math.pow(10, Number(tokenB?.tokenDecimals))}</span> <span className="text-muted">({tokenB?.tokenSymbol})</span>
                                                </div>
                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="text-muted fs-14">{convertDate(_position?.CreatedAt || "")}</div>
                                                    <div className="text-muted fs-14 mx-1">|</div>
                                                    <div>
                                                        <CopyWrapper isShow={true} contentCopy={_position?.position_mint}>
                                                            <span className="fs-14">{_position?.position_mint?.slice(0, 7) + "..." + _position?.position_mint?.slice(-3)}</span>
                                                        </CopyWrapper>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Created at"),
                accessor: "CreatedAt",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original?.campaignInfo;
                    const arrDate = String(item?.CreatedAt || "").split("T");
                    return (
                        <div className="text-end" style={{ minWidth: "120px" }}>
                            <span>
                                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                                <span className="text-secondary">{String(arrDate?.[1] || "")?.split('.')[0]}</span>{" "}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: t("Updated at"),
                accessor: "UpdatedAt",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original?.campaignInfo;
                    const arrDate = String(item?.UpdatedAt || "").split("T");
                    return (
                        <div className="text-end pe-2" style={{ minWidth: "120px" }}>
                            <span>
                                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                                <span className="text-secondary">{String(arrDate?.[1] || "")?.split('.')[0]}</span>{" "}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: t('Action'),
                thWidth: 120,
                thClass: 'text-center align-middle',
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original?.campaignInfo;
                    return (
                        <ul className="list-inline flex-wrap flex-column justify-content-center hstack gap-2 mb-0" style={{ minWidth: '100px' }}>
                            {['DEACTIVATED']?.includes(item?.status) && <li className="list-inline-item me-0" id={`detail-cp-${item?.ID}`}>
                                <Link className={`btn btn-sm px-2 btn-success edit-item-btn`} to="#" style={{ borderRadius: '15px', width: '90px' }}
                                    onClick={(e) => { e.preventDefault(); onOpenConfirmUpdateStatusBotClick({ id: item?.ID, status: 'ACTIVATED' }) }}
                                >
                                    {t('Run Bot')}
                                </Link>
                            </li>}
                            {['ACTIVATED']?.includes(item?.status) && <li className="list-inline-item me-0" id={`detail-cp-${item?.ID}`}>
                                <Link className={`btn btn-sm px-2 btn-danger edit-item-btn`} to="#" style={{ borderRadius: '15px', width: '90px' }}
                                    onClick={(e) => { e.preventDefault(); onOpenConfirmUpdateStatusBotClick({ id: item?.ID, status: 'DEACTIVATED' }) }}
                                >
                                    {t('Stop Bot')}
                                </Link>
                            </li>}
                            <li className="list-inline-item me-0" id={`detail-cp-${item?.ID}`}>
                                <Link className={`btn btn-sm px-2 btn-primary edit-item-btn `} to="#" style={{ borderRadius: '15px', width: '90px' }}
                                    onClick={(e) => { e.preventDefault(); handleDetailCampaign(item?.ID) }}
                                >
                                    {t('Detail')}
                                </Link>
                            </li>
                            <li className="list-inline-item me-0" id={`detail-cp-${item?.ID}`}>
                                <Link className={`btn btn-sm px-2 btn-secondary edit-item-btn `} to="#" style={{ borderRadius: '15px', width: '90px' }}
                                    onClick={(e) => { e.preventDefault(); navigate(`${ROUTES.EVENT_LOG}?id=${item?.ID}`) }}
                                >
                                    {t('Event Log')}
                                </Link>
                            </li>
                            {['DEACTIVATED', 'ACTIVATED']?.includes(item?.status) && <li className="list-inline-item me-0" id={`detail-cp-${item?.ID}`}>
                                <Link className={`btn btn-sm px-2 btn-info edit-item-btn `} to="#" style={{ borderRadius: '15px', width: '90px' }}
                                    onClick={(e) => { e.preventDefault(); handleFundingCampaign(item) }}
                                >
                                    {t('Funding')}
                                </Link>
                            </li>}
                            <li className="list-inline-item me-0" id={`detail-cp-${item?.ID}`}>
                                <Link className={`btn btn-sm px-2 btn-warning edit-item-btn `} to="#" style={{ borderRadius: '15px', width: '90px' }}
                                    onClick={(e) => { e.preventDefault(); handleAllocationCampaign(item) }}
                                >
                                    {t('Allocation')}
                                </Link>
                            </li>
                        </ul>
                    );
                },
            },

        ],
        [i18n?.language, query, isCountdown, assetWallets, isLoadingAssetWallet]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 });
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return { ..._prev, ...sortBy };
        });
    }, []);

    useEffect(() => {
        const list = (optionPools || [])?.map((item: any) => {
            return {
                value: item?.pairAddress,
                label: item?.pairLabel,
                logo1: item?.tokens?.[0]?.tokenLogo,
                logo2: item?.tokens?.[1]?.tokenLogo,
                tokenSymbol1: item?.tokens?.[0]?.tokenSymbol,
                tokenSymbol2: item?.tokens?.[1]?.tokenSymbol,
                tokenAddress1: item?.tokens?.[0]?.tokenAddress,
                tokenAddress2: item?.tokens?.[1]?.tokenAddress,
                tokenDecimals1: item?.tokens?.[0]?.tokenDecimals,
                tokenDecimals2: item?.tokens?.[1]?.tokenDecimals,
                pair: item?.pairLabel || '',
                tokenA: item?.tokenA,
                tokenB: item?.tokenB,
                aToB: item?.tokenA === item?.tokens?.[0]?.tokenAddress,
                tokens: item?.tokens
            };
        });
        setListPool((_prev: any) => list);

    }, [optionPools]);


    useEffect(() => {
        const list = (optionWallets?.list || [])?.map((item: any) => {
            return {
                value: item?.wallets?.pubkey,
                label: item?.wallets?.pubkey,
                balances: customToFixed(Number(item?.balances) / Math.pow(10, 9), 4),
                is_central_wallet: String(item?.wallets?.types) === '1',
            };
        });
        setListWallet((_prev: any) => list);
    }, [optionWallets]);


    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const [res1, res2]: any = await Promise.all([getAllToken({}), getCentralWallet({})]);
                const TOKENS_A = res1?.map((item: any) => {
                    return {
                        value: item?.mint,
                        label: item?.symbol,
                        logo: item?.logo,
                        pair: item?.pair?.pairLabel || '',
                        symbol: item?.symbol,
                        decimals: item?.decimals,
                    };
                });
                const TOKENS_B = TOKENS_DEFAULT?.map((item: any) => {
                    return {
                        value: item?.mint,
                        label: item?.symbol,
                        logo: item?.logo,
                        pair: item?.pair?.pairLabel || '',
                        symbol: item?.symbol,
                        decimals: item?.decimals,
                    };
                });

                setListTokenA((_prev) => (TOKENS_A || []));
                setListTokenB((_prev) => (TOKENS_B || []));
                setWalletCentral((_prev: any) => (res2?.data || null));

            } catch (error: any) {
                return error;
            }
        };
        handleCallAllOption();
    }, []);


    useEffect(() => {
        const handleLoadAssetWallets = async () => {
            setIsLoadingAssetWallet((_prev) => true);
            const ids = campaigns?.list?.map((item: any) => item?.campaignInfo?.ID);
            const arrRes = await Promise.all(ids?.map((id: any) => getAssetCampaign(id)));
            setIsLoadingAssetWallet((_prev) => false);
            const data = arrRes?.map((item: any, index: number) => ({
                ID: ids[index],
                data: item?.data
            }));
            setAssetWallets((_prev) => data || []);
        };
        if (campaigns?.list?.length > 0) {
            handleLoadAssetWallets();
        }
    }, [campaigns?.list]);


    useEffect(() => {
        document.title = `${t("Home")} - ${t("Campaign")}`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);


    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("Campaign")} pageTitle={t("Home")} />
                    <Row>
                        <Col lg={12}>
                            <Card
                                id="customerList"
                                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                            >
                                <CardHeader className="border-0">
                                    <Row className="g-4 align-items-center">
                                        <div className="col-5 con-sm-6">
                                            <div>
                                                <h5 className="card-title mb-0">
                                                    <span className="me-2">{t("Total")}:</span>
                                                    {(isCampaignLoading && !isCallingInterval) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={campaigns?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="col-7 text-end">
                                            <button
                                                type="button"
                                                className="ms-3 btn btn-primary add-btn bg-[#009ef7] hover:bg-[#0086d2]"
                                                id="create-btn"
                                                onClick={() => {
                                                    setIsOpenBotFrom(true);
                                                }}
                                            >
                                                <i className="ri-bilibili-fill align-bottom me-1 "></i>
                                                {t('Create Campaign')}
                                            </button>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                    <Row className="g-4 align-items-center mt-0">
                                        <Col sm={6} md={6} xl={3} xxl={2} className='mt-3'>
                                            <LabelWrapper label={t('Status')} isShow={true}>
                                                <DropdownStatus
                                                    name="type"
                                                    dataList={STATUS_BOT_OPTIONS_LANG || []}
                                                    placeholder={`${t("Status")}...`}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    initialValue={statusSearch || null}
                                                    onChangeSelect={(e: any) => setStatusSearch(e)}
                                                    isHasOptionAll={true}
                                                    optionAll={{ label: t('All'), value: '' }}
                                                    colors={{
                                                        ACTIVATED: 'success',
                                                        DEACTIVATED: 'danger',
                                                        CLOSED: 'warning',
                                                    }}
                                                    isColorObject={true}
                                                />
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={6} md={6} xl={3} xxl={2} className='mt-3'>
                                            <LabelWrapper label={t('Pool')} isShow={true}>
                                                <DropdownPoolOption
                                                    isMultiLang
                                                    name="pool"
                                                    dataList={listPool}
                                                    initialValue={poolSearch || null}
                                                    onChangeSelect={(event: any) => {
                                                        setPoolSearch((_prev: any) => event);
                                                    }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    isShowMore={true}
                                                    labelTop=""
                                                    isHasOptionAll={true}
                                                    optionAll={{
                                                        label: t('All'),
                                                        value: ''
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={6} md={6} xl={3} xxl={2} className='mt-3'>
                                            <LabelWrapper label={t('Wallet')} isShow={true}>
                                                <DropdownWalletOption
                                                    isMultiLang
                                                    name="wallet"
                                                    dataList={listWallet}
                                                    initialValue={walletSearch || null}
                                                    onChangeSelect={(event: any) => {
                                                        setWalletSearch((_prev: any) => event);
                                                    }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    isShowMore={false}
                                                    labelTop=""
                                                    isHasOptionAll={true}
                                                    optionAll={{
                                                        label: t('All'),
                                                        value: ''
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={6} md={6} xl={3} xxl={6} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-xxl-start mt-3">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-2  bg-[#009ef7] hover:bg-[#0086d2]"
                                                    onClick={searchData}
                                                    disabled={(isCampaignLoading && !isCallingInterval)}
                                                >
                                                    <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                    {t('Button Search')}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary fs-14  bg-[#878a99] hover:bg-[#737582]"
                                                    onClick={resetData}
                                                >
                                                    <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                    {t('Button Reset')}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-3">
                                    <TableContainer
                                        className="custom-header-css"
                                        divClass="table-responsive table-card"
                                        tableClass="align-middle sticky-table-campaign"
                                        theadClass="table-light"
                                        columns={columns}
                                        data={campaigns?.list?.length ? campaigns?.list : []}
                                        customPageSize={query.limit}
                                        customPageIndex={query.page - 1}
                                        totalRecords={campaigns?.pagination?.total}
                                        // customPageCount={1}
                                        customPageCount={Math.ceil(
                                            Number(campaigns?.pagination?.total) /
                                            Number(campaigns?.pagination?.limit)
                                        )}
                                        handleChangePage={handleChangePage}
                                        manualSorting={true}
                                        sorting={{
                                            sort_by: query.sort_by,
                                            order_by: query.order_by,
                                        }}
                                        handleChangeSorting={handleChangeSorting}
                                        isLoading={(isCampaignLoading && !isCallingInterval)}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                {(windowSize?.width >= MAX_WIDTH_SCREEN) && (
                    <Offcanvas
                        fade
                        scrollable={false}
                        direction="end"
                        isOpen={isOpenBotFrom}
                        id="offcanvasExample"
                        className='off-canvas-lg off-canvas-lg-600'
                    >
                        <OffcanvasHeader className="bg-light" toggle={handleCloseBotForm}>
                            <h5 className="fs-16 mb-1">{idCampaign ? t('Update Campaign') : t('Create Campaign')}</h5>
                        </OffcanvasHeader>
                        <OffcanvasBody className="color-scrollbar-os">
                            <CampaignConfiguration
                                isOpen={isOpenBotFrom}
                                idCampaign={idCampaign}
                                listTokenA={listTokenA}
                                listTokenB={listTokenB}
                                onClose={handleCloseBotForm}
                                triggerRefresh={() => triggerRefreshBotForm()}
                            />
                        </OffcanvasBody>
                    </Offcanvas>
                )}
                {(windowSize?.width < MAX_WIDTH_SCREEN) && (<Modal
                    isOpen={isOpenBotFrom}
                    centered={true}
                    size="md"
                    toggle={handleCloseBotForm}
                    keyboard={true}
                >
                    <ModalHeader toggle={handleCloseBotForm}>
                        {idCampaign ? t('Update Campaign') : t('Create Campaign')}
                    </ModalHeader>
                    <ModalBody className="">
                        <CampaignConfiguration
                            isOpen={isOpenBotFrom}
                            idCampaign={idCampaign}
                            listTokenA={listTokenA}
                            listTokenB={listTokenB}
                            onClose={handleCloseBotForm}
                            triggerRefresh={() => triggerRefreshBotForm()}
                        />
                    </ModalBody>
                </Modal>)}

                <ModalConfirm
                    header={statusBot?.status === 'ACTIVATED' ? t('Run Bot') : t('Stop Bot')}
                    classButtonConfirm={`${statusBot?.status === 'ACTIVATED' ? 'btn-success  bg-[#50cd89] hover:bg-[#44ae74]' : 'btn-danger bg-[#F8285A] hover:bg-[#d3224d]'}`}
                    isOpen={isOpenConfirmUpdateStatusBot}
                    isLoading={isConfirmUpdateStatusBotLoading}
                    isShowIcon={false}
                    isShowButtonConfirm={true}
                    classIconButtonConfirm=''
                    textButtonConfirm={statusBot?.status === 'ACTIVATED' ? t('Run Bot') : t('Stop Bot')}
                    title={statusBot?.status === 'ACTIVATED' ? t('Are you sure you want to run?') : t('Are you sure you want to stop?')}
                    content={statusBot?.status === 'ACTIVATED' ? t('After confirming the run action, the data will be permanently update and cannot be recovered. Do you want to proceed with the run action.') : t('After confirming the stop action, the data will be permanently update and cannot be recovered. Do you want to proceed with the stop action.')}
                    onClose={onCloseConfirmUpdateStatusBotClick}
                    onConfirm={handleActionUpdateStatusBot}
                />
                <Modal
                    isOpen={fundingCampaign?.ID}
                    centered={true}
                    size="md"
                    toggle={handleCloseFundingCampaign}
                    keyboard={true}
                >
                    <ModalHeader toggle={handleCloseFundingCampaign}>
                        {t('Funding Campaign')}
                    </ModalHeader>
                    <ModalBody className="">
                        <CampaignFunding
                            isOpen={!!fundingCampaign?.ID}
                            campaign={fundingCampaign}
                            listTokenA={listTokenA}
                            listTokenB={listTokenB}
                            walletCentral={walletCentral}
                            onClose={handleCloseFundingCampaign}
                            triggerRefresh={() => triggerRefreshBotForm()}
                        />
                    </ModalBody>
                </Modal>

                <Modal
                    isOpen={allocationCampaign?.ID}
                    centered={true}
                    size="md"
                    toggle={handleCloseAllocationCampaign}
                    keyboard={true}
                >
                    <ModalHeader toggle={handleCloseAllocationCampaign}>
                        {t('Allocation Campaign')}
                    </ModalHeader>
                    <ModalBody className="">
                        <CampaignAllocation
                            isOpen={!!allocationCampaign?.ID}
                            campaign={allocationCampaign}
                            listTokenA={listTokenA}
                            listTokenB={listTokenB}
                            walletCentral={walletCentral}
                            onClose={handleCloseAllocationCampaign}
                            triggerRefresh={() => triggerRefreshBotForm()}
                        />
                    </ModalBody>
                </Modal>

                <ToastContainer autoClose={2000} limit={1} />
            </div>
        </React.Fragment>
    );
}
